import Text from '@shared/components/content/text';
import { Card } from '@shared/components/ui/card';
import { cn } from '@shared/lib/utils';
import { ReactNode } from 'react';

type Props = {
  title: string;
  /** Right-hand header slot: a muted caption or an action link. */
  headerAction?: ReactNode;
  footer?: ReactNode;
  className?: string;
  contentClassName?: string;
  children: ReactNode;
};

/**
 * Panel shell for the item overview cards: a card with a title row, an
 * optional right-hand header slot and an optional footer row.
 */
export function ItemPanel({
  title,
  headerAction,
  footer,
  className,
  contentClassName,
  children,
}: Props) {
  return (
    <Card className={cn('flex flex-col p-5 pt-3', className)}>
      <div className="mb-4 flex min-h-10 items-center justify-between gap-2">
        <Text variant="cardTitle">{title}</Text>
        {headerAction}
      </div>
      <div className={cn('flex-1', contentClassName)}>{children}</div>
      {footer}
    </Card>
  );
}
